import { gsap } from "gsap";
import { Flip } from "gsap/Flip";
import { SplitText } from "gsap/SplitText";
import { useGSAP } from "@gsap/react";

// One place registers the plugins, so a component imports gsap from here
// and never meets an unregistered SplitText or Flip.
gsap.registerPlugin(useGSAP, Flip, SplitText);

// The admin's motion is short and settles softly: it shows where things
// came from and gets out of the way of the work.
gsap.defaults({ ease: "power3.out", duration: 0.45 });

export const REDUCED_MOTION = "(prefers-reduced-motion: reduce)";

/** The system asked for less motion: show the end state straight away. */
export const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  Boolean(window.matchMedia?.(REDUCED_MOTION).matches);

// Transforms left on a container make it the box of its position: fixed
// children (the column resize guide, popups) — clear them once played.
export const SETTLE = "opacity,visibility,transform";

export { gsap, Flip, SplitText, useGSAP };
